import React from 'react';
import { connect } from 'react-redux';
import {
  pageRequest,
  onChangeField,
  hideDetailModal,
} from 'actions/openPlatform/appMarket';
import moment from 'moment';
import { ContentWrapper, PageWrapper } from 'components/wrappers/pages';
import { formValueSelector } from 'redux-form';
import { push } from 'react-router-redux';
import filter from 'lodash/filter';
import * as clevertapOpenPlatformAppMarket from 'clevertap/openPlatform/appMarket';
import * as marketplaceUtil from 'utils/marketplace';
import { refreshSession, getTokenExpiry } from 'utils/auth';
import withFeatureFlags from 'hocs/withFeatureFlags';
import Title from '../Title';
import DetailModal from '../DetailModal';
import AppRow from '../AppRow';
import ActionBar from '../ActionBar';
import styles from './AppMarket.css';

const categoryOptions = [
  {
    id: 'online_ordering',
    name: 'Online Ordering',
    description:
      'Increase your online presence by having your business registered in the Online Ordering application and start receiving your order ahead of time.',
  },
  {
    id: 'accounting',
    name: 'Accounting',
    description:
      "Eliminate manual entries to your accounting software by automatically importing Moka's sales and transaction data. Seamless integration provides accurate and up-to-date accounting insights.",
  },
  {
    id: 'e_commerce',
    name: 'eCommerce Builder',
    description:
      'Kickstart your online presence quickly by syncing your item libraries and start selling more with our eCommerce solutions.',
  },
  {
    id: 'analytics',
    name: 'Analytics & Reporting',
    description:
      'Visualize your reports in a multitude of charts. Combine data from multiple sources in one place to enhance your understanding of the data and make better decisions.',
  },
  {
    id: 'food_delivery',
    name: 'Food Delivery',
    description:
      'Start receiving your online orders notification directly into the Moka POS system. All the online orders transaction will be recorded in Moka BackOffice.',
  },
  {
    id: 'communication',
    name: 'Communication',
    description:
      'Boost your merchant engagement by syncing your customers information that allows you to start exchanging information with them.',
  },
  {
    id: 'enterprise_resource_planning',
    name: 'Enterprise Resource Planning',
    description:
      'Increase your productivity and handle all your business needs efficiently through a single application. Streamline processes and information across the organization into a unified system.',
  },
  {
    id: 'others',
    name: 'Others',
    description:
      'Didn’t see the category you are looking for? Check out the application below to increase the productivity of your business.',
  },
];

const GOFOOD = 'GoFood';
const EATSY = 'Eatsy';

class AppMarket extends React.Component {
  componentDidMount() {
    const request = this.props.location.state || '';
    this.props.dispatch(pageRequest({ request }));
  }

  render() {
    const { apps, showDetailModal, appDetail } = this.props;
    return (
      <PageWrapper>
        <ActionBar
          location={this.props.location}
          fields={['keyword']}
          onChangeField={this._onChangeField}
          categoryOptions={categoryOptions}
        />
        <ContentWrapper>
          <div className={styles.appListWrapper}>
            <div className={styles.appList}>
              {categoryOptions.map(category => {
                const appsPerCategory = filter(apps, { category: category.id });
                if (appsPerCategory.length > 0) {
                  rearrangeAppRow(appsPerCategory, category.id);
                  return (
                    <div className="row no-margin" key={category.id}>
                      <Title
                        noBorder
                        title={
                          category.id !== '' ? category.name : 'Uncategorized'
                        }
                      />
                      {!!category.description && (
                        <p className="mb-20px">{category.description}</p>
                      )}
                      <div>{appsPerCategory.map(this._appRow)}</div>
                      <div className="clearfix" />
                    </div>
                  );
                }
                return <div />;
              })}
            </div>
          </div>
          {appDetail && (
            <DetailModal
              show={showDetailModal}
              app={appDetail}
              onClickClose={this._onClickCloseModal}
              onClickGetStarted={this._onClickLaunch}
            />
          )}
        </ContentWrapper>
      </PageWrapper>
    );
  }

  _appRow = (app, index) => {
    if (app) {
      return (
        <div className={`col-sm-6 ${styles.appCellWrapper}`} key={index}>
          <AppRow
            app={app}
            onClickLearnMore={this._onClickLearnMore}
            onClickLaunch={this._onClickLaunch}
            launchCss={app.is_authorized ? 'btn btn-default' : undefined}
            launchText={app.is_authorized ? 'Manage App' : 'Get Started'}
            defaultStyle
          />
        </div>
      );
    }
  };

  isSessionExpiredInTenMinutes = () => {
    return moment(getTokenExpiry()).diff(moment(), 'minute') <= 10;
  };

  _openNewWindow = app => {
    const { enableCmpLogin } = this.props;

    const url = enableCmpLogin
      ? marketplaceUtil.generateCMPExternalURL(app)
      : marketplaceUtil.generateExternalURL(app);
    window.open(url, '_blank');
  };

  _openExternalAppURL = app => {
    const { enableCmpLogin } = this.props;

    if (enableCmpLogin && this.isSessionExpiredInTenMinutes()) {
      refreshSession().then(() => this._openNewWindow(app));
    } else {
      this._openNewWindow(app);
    }
  };

  _onChangeField = ({ field, value }) => {
    const { searchValues, dispatch } = this.props;
    searchValues[field] = value;
    dispatch(onChangeField({ field, value, searchValues }));
  };

  _onClickLearnMore = ({ app }) => {
    clevertapOpenPlatformAppMarket.appMarketFindOutMore({
      uid: app.uid,
      name: app.name,
    });
  };

  _onClickLaunch = ({ app }) => {
    if (app.is_authorized) {
      clevertapOpenPlatformAppMarket.appMarketManageApp({
        uid: app.uid,
        name: app.name,
      });
      this.props.dispatch(push('/apps/my-app'));
    } else {
      clevertapOpenPlatformAppMarket.appMarketGetStarted({
        uid: app.uid,
        name: app.name,
      });
      this._openExternalAppURL(app);
    }
  };

  _onClickCloseModal = () => {
    this.props.dispatch(hideDetailModal());
  };
}

const selector = formValueSelector('search');

function rearrangeAppRow(appsPerCategory, categoryId) {
  if (categoryId === 'online_ordering') {
    // online order category list: 1: gofood, 2: eatsy, 3: etc
    if (appsPerCategory !== undefined) {
      appsPerCategory.map((app, index) => {
        if (app.name === GOFOOD) {
          moveElement(appsPerCategory, index, 0);
        }
        if (app.name === EATSY) {
          moveElement(appsPerCategory, index, 1);
        }
      });
    }
    return appsPerCategory;
  }
}

function moveElement(arr, old_index, new_index) {
  if (new_index >= arr.length) {
    let k = new_index - arr.length + 1;
    while (k--) {
      arr.push(undefined);
    }
  }
  arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
  return arr;
}

function mapStateToProps(state) {
  const { apps, showDetailModal, appDetail } = state.openPlatform.appMarket;
  return {
    apps,
    appDetail,
    searchValues: {
      keyword: selector(state, 'keyword'),
      category: selector(state, 'category'),
    },
    showDetailModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(AppMarket);

function mapFlagsToProps(flags) {
  return {
    enableCmpLogin: flags.enableCmpLogin,
  };
}

export default withFeatureFlags(mapFlagsToProps)(connected);
